export default {"src":"/_next/static/media/ILMN.1f14e1b6.svg","height":18,"width":18};